import React from "react"
import createTemplate from "../../create-template"

import { useComponents } from "../../components"

function AbbeyThankYou({ styles, ...props }) {
  const Elements = useComponents()
  const background_color = styles.forElement("background").backgroundColor

  return (
    <Elements.LandingPage
      styles={styles}
      {...props}
      style={styles.forElement("page")}
    >
      <div
        className="formkit-background"
        style={{ backgroundColor: background_color }}
      />
      <div
        className="formkit-background"
        style={styles.forElement("background")}
      />
      <div className="formkit-container">
        <header>
          <Elements.Image className="formkit-image" name="logo" />
        </header>
        <div className="formkit-main">
          <div>
            <Elements.Heading
              className="formkit-heading-primary"
              name="header"
              defaults={{
                content: "Thanks for signing up"
              }}
            />
            <Elements.Region className="formkit-content" name="content">
              <Elements.Content
                defaults={{
                  content:
                    "Provide some more detail in this content area. Vestibulum ut ornare lobortis fermentum a consectetur etiam adipiscing litora consectetur dis lorem parturient himenaeos at ridiculus duis at a ad ridiculus parturient ipsum enim lorem scelerisque."
                }}
              />
            </Elements.Region>
          </div>
        </div>
      </div>
      <Elements.BuiltWith background="background" image="background" />
    </Elements.LandingPage>
  )
}

AbbeyThankYou.style = "landing_page"
AbbeyThankYou.categories = ["Event", "Newsletter", "Profile", "Waitlist"]
AbbeyThankYou.thumbnail = ""
AbbeyThankYou.preview = "https://demo.ck.page/abbey"
AbbeyThankYou.fields = []

export default createTemplate(AbbeyThankYou, { name: "AbbeyThankYou" })
